import React, { useEffect, useRef, useState } from "react";
import {useEventContext} from '../context/EventContext';
import {getPrivacyOffers} from '../../../../platform/src/utils/getPrivacyOffers';
import createCssVariables from "../core/utils/createCssVariables";
import RegistrationForm from './RegistrationForm';
import Notifications from './Notifications';
import moment from "moment";
import { useLocaleContext } from "../../../../platform/src/context/LocaleContext";

const RegistrationWrapper = (
    {
        isSuccess,
        isFormVisible,
        params,
        onSuccess,
        onError,
        onCloseNotification,
        clientEmail,
        widgetSettings,
        widgetFields,
        onChangeFormVisibility,
        onUpdateFields,
    }
) => {
    const {event} = useEventContext();
    const $locale = useLocaleContext();
    const registrationRef = useRef(null);
    const [settings, setSettings] = useState(null);

    const [unformattedDateStart, timeStart] = moment.unix(event.timeStart).format('YYYY-MM-DD HH:mm').split(' ');
    const [unformattedDateStop, timeStop] = moment.unix(event.timeStop).format('YYYY-MM-DD HH:mm').split(' ');
    const dateOptions = {
        day: 'numeric',
        year: 'numeric',
        month: 'long',
    };
    const dateStart = new Date(unformattedDateStart).toLocaleDateString(undefined, dateOptions);
    const dateStop = new Date(unformattedDateStop).toLocaleDateString(undefined, dateOptions);

    const placeholdersData = {
        eventName: event[`name_${$locale.name}`],
        dateStart,
        timeStart,
        dateStop,
        timeStop,
        userEmail: clientEmail,
    };

    useEffect(() => {
        setSettings(widgetSettings ?? null);
    }, []);

    useEffect(() => {
        const messageHandler = (event) => {
            try {
                const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;

                if (!data) return;

                data?.hasOwnProperty('changeWidgetSettings') && setSettings({
                    ...widgetSettings,
                    ...data.changeWidgetSettings,
                });

                data?.hasOwnProperty('isFormVisible') && onChangeFormVisibility(data.isFormVisible);

                data?.hasOwnProperty('isPreviewUpdated') && onUpdateFields(data.isPreviewUpdated);
            } catch (error) {
                console.error(error);
            }
        };

        window.addEventListener('message', messageHandler);

        return () => {
            window.removeEventListener('message', messageHandler);
        }
    }, []);

    useEffect(() => {
        if (!settings) return;

        const registration = registrationRef.current;
        createCssVariables(registration, settings);

        if (!settings.font) return;

        const link = document.createElement('link');
        const fontPath = settings.font.split(' ').join('');
        link.setAttribute('rel', 'stylesheet');
        link.setAttribute('type', 'text/css');
        link.setAttribute('href', `/files/fonts/${fontPath}/stylesheet.css`);
        document.head.appendChild(link);

        return () => {
            document.head.removeChild(link);
        }
    }, [settings]);

    return (
        <div
            ref={registrationRef}
            className="registration"
        >
            {isFormVisible
                ? <RegistrationForm
                    eventKey={event.eventKey}
                    eventName={event[`name_${$locale.name}`]}
                    placeholdersData={placeholdersData}
                    participationType={event.participationType}
                    yaCode={event.moduleBranding.yandexMetrika}
                    accessPreModeration={event.moduleAuth.accessPreModeration}
                    $locale={$locale}
                    params={params}
                    onSuccess={onSuccess}
                    onError={onError}
                    settings={settings}
                    widgetFields={widgetFields}
                    corporateMail={event.moduleAuth.corporateMail}
                    registrationType={event.moduleAuth.registrationType ?? 'hybrid'}
                />
                : <Notifications
                    $locale={$locale}
                    eventKey={event.eventKey}
                    eventName={event[`name_${$locale.name}`]}
                    accessPreModeration={event.moduleAuth.accessPreModeration}
                    yaCode={event.moduleBranding.yandexMetrika}
                    clientEmail={clientEmail}
                    placeholdersData={placeholdersData}
                    settings={settings}
                    isSuccess={isSuccess}
                    onCloseNotification={onCloseNotification}
                />
            }
        </div>
    );
};

export default RegistrationWrapper;
